module.exports = __webpack_public_path__ + "static/media/pic5.1b81cfc0.jpg";